"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.494 6.858a1.424 1.424 0 0 0-1.997 0 1.373 1.373 0 0 0 0 1.957c.55.545 1.446.545 1.997 0a1.373 1.373 0 0 0 0-1.957m-2.982-.995a2.824 2.824 0 0 1 3.967 0 2.773 2.773 0 0 1 0 3.947 2.824 2.824 0 0 1-3.967 0 2.773 2.773 0 0 1 0-3.947m8.33 1.206a.818.818 0 1 0-1.157 1.156.818.818 0 0 0 1.157-1.156m-2.147-.99a2.218 2.218 0 1 1 3.137 3.137 2.218 2.218 0 0 1-3.137-3.137m.11 4.892a.7.7 0 0 1 .7-.7h2.277c1.225 0 2.218.992 2.218 2.218v.38a.7.7 0 1 1-1.4 0v-.38a.82.82 0 0 0-.818-.819h-2.277a.7.7 0 0 1-.7-.7m-6.418 1.475a.98.98 0 0 0-.987.97v.835a.7.7 0 1 1-1.4 0v-.835a2.38 2.38 0 0 1 2.387-2.37h4.217a2.38 2.38 0 0 1 2.386 2.37v.835a.7.7 0 1 1-1.4 0v-.835c0-.53-.435-.97-.986-.97z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UserGroupIcon20.js.map